import { useEffect, useState, useRef } from "react";
import { useFetcher } from "react-router-dom";
import copyToClipboard from "copy-to-clipboard";
import clsx from "clsx";

import CopyIcon from "../icons/copy-icon";
import DownloadIcon from "../icons/download-icon";
import ResponseNew from "../Demo/ResponseNew";
import LinkBigIcon from "../icons/link-big-icon/index";
import { toFarsiNumber } from "./utils";
import { Spinner } from "./Spinner";
import { time_to_second } from "../Demo/utils/functions";
import { getRequestFromId, patchRequest } from "./data";
import EditIcon from "../icons/edit-icon";
import CloseIcon from "../icons/close-icon";
import TickIcon from "../icons/tick-icon";
import { errorNotify, successNotify } from "../notify/toastify";

const ItemGrid = ({ itemData }) => {
  let [isOpen, setIsOpen] = useState(false);
  const [loadImage, setLoadImage] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [finalResponse, setFinalResponse] = useState(null);
  const [isWaitingToCopy, setIsWaitingToCopy] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const fetcher = useFetcher();
  const url = itemData.url;
  const fileExtension = url.split(".").pop();
  const fileName =
    itemData.filename === `.${fileExtension}` ||
    itemData.filename === "" ||
    itemData.filename == null ||
    itemData.filename == undefined
      ? url.split("/").pop()
      : itemData.filename.split(".").slice(0, -1).join(".");
  const [fileEdit, setFileEdit] = useState(fileName);
  const duration = toFarsiNumber(itemData.duration || "04:20:00");
  const dialogRef = useRef(null);
  let data = null;

  if (fetcher.data) {
    const responseData = fetcher.data;
    if (responseData && !isOpen) {
      data = responseData.segments;
    }
  }

  useEffect(() => {
    const clickHandle = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        closeModal();
        setFinalResponse(null);
      }
    };
    document.addEventListener("mousedown", clickHandle);
    return () => {
      document.removeEventListener("mousedown", clickHandle);
    };
  }, []);

  useEffect(() => {
    if (isWaitingToCopy && data && !isOpen) {
      const textToCopy = data
        .map((segment) => segment.text)
        .filter((text) => text)
        .join(". ");
      copyToClipboard(textToCopy);
      setIsWaitingToCopy(false);
      successNotify({text:"متن با موفقیت کپی شد"})
    }
  }, [data, isWaitingToCopy]);

  const handleCopy = async () => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(`/archive/requests/${itemData.id}`);
    }
    setIsWaitingToCopy(true);
  };

  const downloadHandler = () => {
    const tag = document.createElement("a");
    tag.setAttribute("href", url);
    tag.setAttribute("target", "_blank");
    tag.setAttribute("rel", "noopener noreferrer");
    tag.click();
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = async () => {
    setIsOpen(true);
    setLoadingResults(true);
    const response = await getRequestFromId({ id: itemData.id });

    if (response) {
      setFinalResponse({
        ...response,
        duration: time_to_second(response.duration),
      });
    }
    setLoadingResults(false);
  };

  const openEdit = () => {
    setIsEdit(true);
  };

  const closeEdit = () => {
    setIsEdit(false);
    setFileEdit(fileName);
  };

  const changeFilename = (e) => {
    setFileEdit(e.target.value);
  };

  const handleEdit = async () => {
    try {
      await patchRequest({
        id: itemData.id,
        filename: fileEdit,
        prefix: fileExtension,
      });
      setIsEdit(false);
      successNotify({ text: "با موفقیت ویرایش شد" });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      errorNotify({ text: "مشکلی پیش آمده" });
    }
  };

  return (
    <>
      <div className="item">
        <div className="item-top" onClick={openModal}>
          <div
            className="item-top-pre-thumbnail"
            style={!loadImage ? { display: "flex" } : { display: "none" }}
          >
            <LinkBigIcon width={32} height={39} />
            <span className="file-duration">{duration}</span>
          </div>
          <div
            className="item-top-thumbnail"
            style={
              loadImage && !imageError
                ? { display: "flex" }
                : { display: "none" }
            }
          >
            <img
              alt=""
              src={`/media_image/${url}`}
              onLoad={() => setLoadImage(true)}
              onError={() => setImageError(true)}
              style={{ width: "100%", height: "100%" }}
            />
            <span className="file-duration">{duration}</span>
          </div>
        </div>
        <div className="item-bottom">
          <span className="title">{fileName}</span>
          {!isEdit ? (
            <div className="tools">
              <button onClick={downloadHandler}>
                <DownloadIcon width={14} height={13} color="#fff" />
              </button>
              <div onClick={openEdit}>
                <EditIcon
                  width={15}
                  height={15}
                  style={{ cursor: "pointer", marginTop: "-4px" }}
                />
              </div>
              <div onClick={handleCopy}>
                {isWaitingToCopy && !data ? (
                  <Spinner
                    width={25}
                    height={27.09}
                    innerSize={15}
                    color="#c1c1c1"
                  />
                ) : (
                  <CopyIcon
                    width={13}
                    height={15}
                    color="#303030"
                    style={{ cursor: "pointer", marginTop: "-4px" }}
                  />
                )}
              </div>
            </div>
          ) : (
            <div
              className="tools"
              style={{
                borderRadius: "50px",
                backgroundColor: "#F8F8F8",
                padding: "4px 8px 4px 8px",
              }}
            >
              <input
                className="edit-input"
                type="text"
                onChange={(e) => changeFilename(e)}
                value={fileEdit}
                style={{ textOverflow: "ellipsis" }}
              ></input>
              <TickIcon
                width={12}
                height={12}
                style={{ cursor: "pointer", marginTop: "0.1rem" }}
                onClick={handleEdit}
              />
              <CloseIcon
                height={12}
                width={12}
                color={"#939393"}
                style={{ cursor: "pointer", marginTop: "0.1rem" }}
                onClick={closeEdit}
              />
            </div>
          )}
        </div>
      </div>
      {/* Modal - Response */}
      <div className={clsx("modal", isOpen ? "modal-enter" : "modal-leave")}>
        <div
          className={clsx("dialog", isOpen ? "dialog-enter" : "dialog-leave")}
          dir="ltr"
          ref={dialogRef}
        >
          {finalResponse && (
            <ResponseNew finalResponse={finalResponse} isArchive={true} />
          )}
          {loadingResults && (
            <div className="response-new no-padding">
              <div className="atom-spinner">
                <div className="spinner-inner">
                  <div className="spinner-line"></div>
                  <div className="spinner-line"></div>
                  <div className="spinner-line"></div>
                  <div className="spinner-circle">&#9679;</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ItemGrid;
